<template lang="pug">
div.row
    div.col-xs-6
        div.md-form-group.p-t-0
            label.typo__label.multiselect-label.font-sm Ingredient
            multiselect(
                track-by="id"
                label="name"
                :options="ingredientList"
                :loading="onLoading('fetch-ingredients')"
                v-model="modifier.ingredient.ingredient"
                :allow-empty="false"
                v-validate="'required'"
                :data-vv-scope="`modifier_${modifier.sequence}_ingredient`"
                @search-change="loadIngredients"
            )
            span.small.text-danger(v-if="errors.has(`ingredient_${modifier.sequence}`)")
                    | {{ errors.first(`ingredient_${modifier.sequence}`) }}

    div.col-xs-3
        div.md-form-group
            input.md-input.m-t-1.small(
                v-model="modifier.ingredient.ingredient.uom"
                disabled
            )
            label Measurement

    div.col-xs-2
        div.md-form-group
            input.md-input.m-t-1(
                v-if="modifier.mode == 1"
                type="number"
                v-model="modifier.ingredient.portion"
                min="0"
                step="any"
                required
            )

            select.md-input.m-t-1(
                v-else
                v-model="modifier.ingredient.portion"
                name="portion"
            )
                option(:value="0.5") 50%
                option(:value="1") 100%

            label Portion (#)

    div.col-xs-1
        label.md-label Track
        label.md-check.p-t-3
            input.has-value(
                type="checkbox"
                name="preselected"
                v-model="modifier.ingredient.track"
            )
            i.indigo
</template>

<script>
import ingredientStoreMixin from '../../inventory-fnb/ingredient/store-mixin';
import handleValidatorUI from '@js/mixins/handle-validator-ui';
import { mapActions, mapGetters } from 'vuex';

export default {
    inject: ['$validator'],

    mixins: [ingredientStoreMixin, handleValidatorUI],

    props: {
        modifier: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            hasValidationError: false,
        };
    },

    computed: {
        ...mapGetters('ingredient', ['ingredientList']),

        mode() {
            return this.modifier.mode;
        },
    },

    watch: {
        mode: {
            immediate: true,
            handler(m) {
                if (!this.modifierExists) {
                    if (m == 2) {
                        this.modifier.ingredient.portion = 0.5;
                    }
                }
            },
        },
    },

    mounted() {
        if (_.isEmpty(this.ingredientList)) {
            this.loadIngredients();
        }
    },

    methods: {
        ...mapActions('ingredient', ['getIngredientList']),

        validate() {
            this.hasValidationError = false;

            this.validateField(
                this.modifier.ingredient.ingredient.id,
                `ingredient_${this.modifier.sequence}`,
                'ingredient',
            );
        },

        loadIngredients: _.debounce(function(query = '') {
            const params = {
                query,
                outlet_id: this.modifier.outlet_id,
            };

            this.getIngredientList(params);
        }, 500),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/modifier/modifier-ingredient.vue